/* sm-home-text-card — flower tooltips. Port of Manukora section-card-text.js.
   Desktop: hover opens (closes 100ms after leaving unless pointer is on the tooltip). Mobile (≤768): tap toggles.
   Outside click / scroll / resize / Escape close. One open at a time. Guarded for multiple section instances. */
(function () {
  if (window.SmTextCard) { window.SmTextCard.setupAll(); return; }
  var active = null;
  function isMobile() { return window.innerWidth <= 768; }
  function closeActive() {
    if (!active) return;
    active.btn.classList.remove('is-active'); active.btn.setAttribute('aria-expanded', 'false');
    active.tip.classList.remove('is-show', 'is-flipped'); active.tip.setAttribute('aria-hidden', 'true');
    active.tip.style.top = ''; active.tip.style.left = '';
    active = null;
  }
  function open(btn, tip) {
    if (active && active.btn === btn) return;
    closeActive();
    var rect = btn.getBoundingClientRect();
    var sx = window.pageXOffset, sy = window.pageYOffset;
    tip.innerHTML = '';
    var icon = document.createElement('span'); icon.className = 'sm-home-text-card__tt-icon';
    var svg = btn.querySelector('svg'); if (svg) icon.innerHTML = svg.outerHTML;
    var text = document.createElement('div'); text.className = 'sm-home-text-card__tt-text'; text.innerHTML = btn.getAttribute('data-tooltip') || '';
    tip.appendChild(icon); tip.appendChild(text);
    tip.classList.add('is-show'); tip.setAttribute('aria-hidden', 'false');
    var tW = tip.offsetWidth, tH = tip.offsetHeight;
    var pad = isMobile() ? 10 : 16, ww = window.innerWidth, wh = window.innerHeight, margin = 20;
    var spaceRight = ww - rect.right;
    var flip = spaceRight < (tW - rect.width - pad + margin);
    if (flip) { tip.classList.add('is-flipped'); tip.insertBefore(text, icon); } else { tip.classList.remove('is-flipped'); }
    var left = flip ? (rect.left + sx - (tW - pad - rect.width)) : (rect.left + sx - pad);
    var top = rect.top + sy - (tH - rect.height) / 2;
    var rOver = (left - sx) + tW - ww; if (rOver > margin) left = left - rOver - margin;
    var bOver = (top - sy) + tH - wh; if (bOver > margin) top = top - bOver - margin;
    if (left < sx + margin) left = sx + margin;
    if (top < sy + margin) top = sy + margin;
    tip.style.left = Math.round(left) + 'px'; tip.style.top = Math.round(top) + 'px';
    btn.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true');
    active = { btn: btn, tip: tip };
  }
  function setup(section) {
    if (section.dataset.smInit) return; section.dataset.smInit = '1';
    var tip = section.querySelector('.sm-home-text-card__tooltip'); if (!tip) return;
    document.body.appendChild(tip);
    var timer = null;
    section.querySelectorAll('.sm-home-text-card__flower').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        if (isMobile() && active && active.btn === btn) closeActive(); else open(btn, tip);
      });
      btn.addEventListener('mouseenter', function () { if (isMobile()) return; clearTimeout(timer); open(btn, tip); });
      btn.addEventListener('mouseleave', function () { if (isMobile()) return; timer = setTimeout(closeActive, 100); });
    });
    tip.addEventListener('mouseenter', function () { clearTimeout(timer); });
    tip.addEventListener('mouseleave', function () { if (!isMobile()) closeActive(); });
    tip.addEventListener('click', function (e) { if (e.target.closest('a')) return; e.stopPropagation(); closeActive(); });
  }
  function setupAll() { document.querySelectorAll('.sm-home-text-card').forEach(setup); }
  document.addEventListener('click', function (e) { if (active && !active.tip.contains(e.target)) closeActive(); });
  window.addEventListener('scroll', closeActive, { passive: true });
  window.addEventListener('resize', closeActive);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeActive(); });
  document.addEventListener('shopify:section:load', setupAll);
  window.SmTextCard = { setupAll: setupAll, close: closeActive };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
})();
